import { z } from 'zod';
import { legalClientSchema } from './ILegalClient';
import { invoicePaidSchema } from './IInvoicePaid';
import { invoicePaidPlanSchema } from './IInvoicePaidPlan';

export const invoiceSchema = z.object({
  idInvoice: z.number().default(-1),
  idLegalTransaction: z.number().default(-1),
  idLegalTransactionType: z.number().default(-1),
  idInvoiceState: z.number().default(1),
  idDocument: z.number().default(-1),
  EPCString: z.string().nullable().default(null),
  Total: z.number().nullable().default(null),
  InvoiceNumber: z.string().default(''),
  isDeadlineSuspended: z
    .union([z.boolean(), z.number().transform(val => Boolean(val))])
    .transform(val => Boolean(val))
    .default(true),
  PaymentDueDate: z.string().default(new Date().toISOString().split('T')[0]),
  // Über Relationen
  Title: z.string().optional(),
  FileName: z.string().default(''),
  idMIMEType: z.number().default(-1),
  Data: z.string().optional(),
  Created_at: z.string().default(new Date().toISOString().split('T')[0]),

  idLegalTransactionRecordNumber: z.number().nullable().default(null),
});

// Erweiterung: z.B. mit zusätzlichen Relationen oder berechneten Feldern

// Erweiterung: z.B. mit zusätzlichen Relationen oder berechneten Feldern
export const invoiceFullSchema = invoiceSchema.extend({
  LegalClients: z.number().array().default([]),
  LegalTransactionLegalClients: z.array(legalClientSchema).default([]),
  InvoicePaids: z.array(invoicePaidSchema).default([]),
  InvoicePaidPlans: z.array(invoicePaidPlanSchema).default([]),
});

export type IInvoice = z.infer<typeof invoiceSchema>;
export type IInvoiceFullObject = z.infer<typeof invoiceFullSchema>;
